<template>
  <ul class="grid gap-2">
    <SeanceListItem
      v-for="seance in viewedItems"
      :key="seance.id"
      :value="seance"
      :type="type"
      :mode
      @click="emit('click', seance.id)"
    />
  </ul>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { Event } from '@/5_entities/Event'
import type { TimetableFilterMode } from '@/6_shared/model'
import type { Seance } from '../../model'
import SeanceListItem from './SeanceListItem.vue'

type PropType = {
  value: Seance[]
  maxItems?: number
  type?: 'link' | 'button'
  mode: TimetableFilterMode
}

const props = withDefaults(defineProps<PropType>(), {
  maxItems: undefined,
  type: 'link'
})
const emit = defineEmits<EmitType>()
type EmitType = {
  (e: 'openTimetable', eventId: Event['id']): void
  (e: 'click', seanceId: Seance['id']): void
}
const viewedItems = computed(() => {
  if (!props.maxItems) return props.value

  return props.value.filter((_item, index) => index < props.maxItems!)
})
</script>
